import styled from "styled-components";
import { Title } from "theme/theme";
import { Type } from "theme/types";

export const TitleCheckpointQr = styled(Title)`
  ${({theme}: Type) => theme?.trivias?.triviaQr?.title}
`;

export const DescriptionCheckpointQr = styled.div`
  ${({ theme }: Type) => theme?.trivias?.triviaQr?.description}
`;

export const ImgCheckpointQr = styled.img`
  ${({ theme }: Type) => theme?.trivias?.triviaQr?.img}
`;

export const ContainerCheckpointQr = styled.div`
  ${({ theme }: Type) => theme?.trivias?.triviaQr?.container}
`

export const TitleCheckpoint = styled(Title)`
  ${({theme}: Type) => theme?.surveys?.text?.title}
`

export const TitleCheckpointPolaris = styled(Title)`
  ${({ theme }: Type) => theme?.surveys?.text?.titlePolaris}
`

export const CardContainerCheckpoint = styled.div` 
  ${({ theme }: Type) => theme?.surveys?.card?.container}
`

export const ImgCardCheckpoint = styled.img`
  ${({ theme }: Type) => theme?.surveys?.card?.img}
`

export const ImgBottomCheckpoint = styled.img`
  ${({ theme }: Type) => theme?.surveys?.imgBottom}
`

export const TextCardCheckpoint = styled.p`
  ${({ theme }: Type) => theme?.surveys?.card?.text}
`